import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const ArticlesSliderContainer = styled.section`
  width: 100%;

  .slider-content {
    align-items: flex-start;
  }

  .arrow-left-container {
    margin-top: 200px;

    > svg {
      padding-right: 25px;
    }

    @media all and (max-width: ${layout.md}) {
      margin-top: 130px;
    }
  }

  .arrow-right-container {
    margin-top: 200px;

    > svg {
      padding-left: 25px;
    }

    @media all and (max-width: ${layout.md}) {
      margin-top: 130px;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    .arrow-left-container > svg {
      margin-left: 10px;
    }

    .arrow-right-container > svg {
      margin-right: 10px;
    }
  }
`;
